import { useEffect, useState } from "react";
import PageTitle from "../../../Components/Layout/UserDashLyout/PageTitle";
import { usePlayerAccount } from "../../../APIContext/PlayerAccountContext";
import Swal from "sweetalert2";
import "./mypackage.css";
import { data } from "react-router-dom";

const MyPackagesPlans = () => {
  const { fetchParentPackages, cancelSubscription } = usePlayerAccount();
  const [packageData, setPackageData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await fetchParentPackages();
      if (result) {
        setPackageData(result);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch packages.",
          confirmButtonColor: "#B79527", // orange / gold
          cancelButtonColor: "#1C1C1C",
        });
      }
    };

    fetchData();
  }, []);

  const handlecancelSubscription = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to cancel this subscription?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      confirmButtonText: "Yes, cancel it!",
    }).then((result) => {
      if (result.isConfirmed) {
        let data = {
          sale_id: id,
        };
        cancelSubscription(data);
      } else {
        return;
      }
    });
  };

  return (
    <>
      <PageTitle
        showDescription={true}
        description="Manage your current packages, view usage, and stay on top of renewals."
        showButton={false}
        title="My Packages & Plans"
      />
      <div className="profile-detail-container">
        <div className="package-table">
          <div className="table-header">
            <span className="black-text-clip">Package Name</span>
            <span className="black-text-clip">Price ($)</span>
            <span className="black-text-clip">Player</span>
            <span className="black-text-clip">Credits Remaining</span>
            <span className="black-text-clip">Session Type</span>
            <span className="black-text-clip">Package Status</span>
            {/* <span>Action</span> */}
          </div>

          {packageData.length > 0 ? (
            packageData.map((item, index) => (
              <div className="table-row" key={index}>
                <span className="black-text-clip" data-label="Order ID">
                  <span className="package-title-mobile">Package Name: </span>
                  {item.package?.name}
                </span>
                <span
                  className="black-text-clip"
                  data-label="Subscribed Package"
                >
                  <span className="package-title-mobile">Price ($): </span>
                  {item.package?.price}
                </span>
                <span
                  className="black-text-clip"
                  data-label="Credits Remaining"
                >
                  <span className="package-title-mobile">Player: </span>
                  {item.player?.name}
                </span>
                <span
                  className="black-text-clip"
                  data-label="Next Bill (YYYY-MM-DD)"
                >
                  <span className="package-title-mobile">
                    Credits Remaining:{" "}
                  </span>
                  {item.is_unlimited === true
                    ? "Unlimited"
                    : item.remaining_sessions}
                </span>
                <span className="black-text-clip" data-label="Package Status">
                  <span className="package-title-mobile">Session Type </span>
                  {item.package?.is_group_session === true
                    ? "Group"
                    : "Individual"}
                </span>
                <span className="black-text-clip" data-label="Subscription">
                  <span className="package-title-mobile">Status: </span>
                  {item.status}
                </span>
                {/* <span data-label="Action"><span className="package-title-mobile">Action: </span><button className="cancel-subscription" onClick={() => handlecancelSubscription(item.id)}>Cancel Subscription</button></span> */}
              </div>
            ))
          ) : (
            <div className="no-package black-text-clip">No Packages Available</div>
          )}
        </div>
      </div>
    </>
  );
};
export default MyPackagesPlans;
